import { CInput } from "@coreui/react";
import Avatar from "@material-ui/core/Avatar";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import axios from "axios";
import React, { useState } from "react";
import { COLORS } from "../../constants/Colors";
import { iStaffBaseURL } from "../../constants/Urls";
import { notify } from "../../functions/function";
import { connect } from "react-redux";
import DeleteClientModal from "./DeleteClientModal";
import { axiosTimeout } from "src/constants/Axios";

const ClientTableRow = ({ row, dispatch, labelId, userToken, clients }) => {
  const [state, setState] = useState({
    client_logo_uri: row.client_logo_uri,
    istaff_id: row.istaff_id,
    loading: false,
  });

  const [showModal, setShowModal] = useState({
    show: false,
    event: null,
  });

  const handleModalClose = () => {
    setShowModal({ ...showModal, show: false, event: null });
  };

  const handleShowModal = () => {
    setShowModal({ ...showModal, show: true, event: null });
  };

  const submitSave = () => {
    setState({ ...state, loading: true });
    axios
      .put(
        iStaffBaseURL + "/handler/clients/" + row.id,
        {
          ...row,
          user: row.user ? row.user.id : null,
          client_logo_uri: state.client_logo_uri,
          istaff_id: state.istaff_id,
        },
        {
          headers: { Authorization: "Token " + userToken },
          timeout: axiosTimeout,
        }
      )
      .then((response) => {
        console.log(response);
        notify("Success", "Client details updated.", "success");
      })
      .catch((error) => {
        console.log(error);
        notify(
          "Error",
          "Client details failed to be updated. Please try again",
          "danger"
        );
      })
      .finally(() => {
        setState({ ...state, loading: false });
      });
  };

  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={state.isSelected}
      tabIndex={-1}
      key={row.id}
    >
      <TableCell align="center">
        <div class="row">
          <div class="col justify-content-center">
            <Avatar
              variant="square"
              src={row.client_logo_uri}
              alt={row.company_name}
            />
          </div>
        </div>
      </TableCell>

      <TableCell
        component="th"
        id={labelId}
        scope="row"
        padding="none"
        align="center"
      >
        {row.company_name}
      </TableCell>

      <TableCell align="center">{row.company_contact}</TableCell>

      <TableCell align="center">{row.company_address}</TableCell>

      <TableCell align="center" className="">
        <CInput
          value={state.client_logo_uri}
          onChange={(val) => {
            setState({ ...state, client_logo_uri: val.currentTarget.value });
          }}
        />
      </TableCell>

      <TableCell align="center" className="">
        <CInput
          value={state.istaff_id}
          onChange={(val) => {
            setState({ ...state, istaff_id: val.currentTarget.value });
          }}
        />
      </TableCell>

      <TableCell align="center" className="text-warning">
        {state.loading ? (
          <div
            class="spinner-border spinner-border-sm text-success"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        ) : (
          <button
            type="button"
            class="btn btn-success justify-self-center"
            style={{ color: COLORS.WHITE }}
            onClick={() => {
              submitSave();
            }}
          >
            Save Changes
          </button>
        )}
      </TableCell>

      <TableCell align="center" className="text-warning">
        {state.loading ? (
          <div
            class="spinner-border spinner-border-sm text-success"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        ) : (
          <button
            type="button"
            class="btn btn-danger justify-self-center"
            style={{ color: COLORS.WHITE }}
            onClick={() => {
              handleShowModal();
            }}
          >
            Delete
          </button>
        )}
        <DeleteClientModal
          show={showModal.show}
          handleClose={handleModalClose}
          event={showModal.event}
          row={row}
        />
      </TableCell>
    </TableRow>
  );
};

function mapStateToProps(state) {
  return {
    clients: state.userPlacementsReducer.clients,
  };
}

export default connect(mapStateToProps)(ClientTableRow);
